import React, { memo } from 'react';
import PropTypes from 'prop-types';

import styles from './styles/HelpText.module.css';

const HelpText = ({ children, className = '', ...props }) => {
    return (
        <small className={`${styles.helpText} ${className}`} {...props}>
            {children}
        </small>
    );
};

HelpText.propTypes = {
    children: PropTypes.node.isRequired,
    className: PropTypes.string,
};

export default memo(HelpText);
